// composables/useBreadcrumbs.ts

import { computed } from 'vue';
import { useRoute, type RouteLocationNormalizedLoaded } from 'vue-router';

const pathNames: Record<string, string> = {
    dashboard: 'Dashboard',
    vps: 'Virtual Private Servers',
    auth: 'Authentication',
    login: 'Login',
    register: 'Register',
    ips: 'IPs',
};

export interface Breadcrumb {
    label: string;
    disabled: boolean;
    to: string;
}

const buildBreadcrumbs = (route: RouteLocationNormalizedLoaded): Breadcrumb[] => {
    const segments = route.path.split('/').filter(Boolean);
    const crumbs: Breadcrumb[] = [];
    let path = '';

    // Always show dashboard as first crumb (except when already on /dashboard)
    if (route.path !== '/dashboard') {
        crumbs.push({
            label: pathNames.dashboard ?? 'Dashboard',
            to: '/dashboard',
            disabled: false,
        });
    }

    segments.forEach((segment, index) => {
        path += `/${segment}`;

        const matchedRoute = route.matched[index];
        const metaLabel = matchedRoute?.meta?.breadcrumb as string | undefined;
        const overrideLabel = pathNames[segment];

        const label =
            metaLabel || // 1) meta.breadcrumb on the route
            overrideLabel || // 2) pathNames override
            segment.charAt(0).toUpperCase() + segment.slice(1); // 3) Fallback: Capitalised segment

        crumbs.push({
            label,
            to: path,
            disabled: index === segments.length - 1,
        });
    });

    return crumbs;
};

export const useBreadcrumbs = () => {
    const route = useRoute();

    const breadcrumbs = computed(() => buildBreadcrumbs(route));

    return {
        breadcrumbs,
    };
};
